import React from "react";

import "./Image.scss";

const Image = ({ link, className, alt }) => {
  return <img className={className ? 'app-image ' + className : 'app-image'} src={link} alt={alt} />;
};

export default Image;
